import { useEffect } from "react";

const GA_ID = "G-YKX0NWRW2M";

const loadGoogleAnalytics = () => {
  // Prevent duplicate script installation
  if (document.getElementById("google-analytics-script")) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  // Queue consent before configuring Analytics
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied"
  });

  window.gtag("consent", "update", {
    analytics_storage: "granted"
  });

  const script = document.createElement("script");

  script.id = "google-analytics-script";
  script.async = true;
  script.src =
    `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
};

const GoogleAnalytics = () => {
  useEffect(() => {
    const applyConsent = () => {
      const consent = localStorage.getItem("cookieConsent");

      if (consent === "accepted") {
        loadGoogleAnalytics();
      } else if (typeof window.gtag === "function") {
        // Update consent if the visitor previously loaded Analytics
        window.gtag("consent", "update", {
          analytics_storage: "denied",
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied"
        });
      }
    };

    applyConsent();

    window.addEventListener("cookieConsentChanged", applyConsent);

    return () => {
      window.removeEventListener(
        "cookieConsentChanged",
        applyConsent
      );
    };
  }, []);

  return null;
};

export default GoogleAnalytics;